import { NavActivity, NavActivities } from '../types/navigation'
import { useIconMeta } from './iconMeta'

type UseNavActivityReturn = {
  /** Returns a single nav activity */
  get: (activity: NavActivity['type']) => NavActivity
  /** Returns an array of selected activities */
  select: (activities: NavActivity['type'][]) => NavActivities
  /** Returns all but omits any supplied activities */
  all: (options?: { omit: NavActivity['type'][] }) => NavActivities
}
export const useNavActivity = (): UseNavActivityReturn => {
  //Get associated data for nav items
  const getActivityData = (type: NavActivity['type']) => {
    return { type: type, icon: useIconMeta(type).icon!, color: useIconMeta(type).color }
  }
  const navActivities: NavActivities = (
    [
      'travel',
      'store',
      'communication',
      'material',
      'coupon',
      'break',
      'training',
      'team',
      'other',
    ] as NavActivity['type'][]
  ).map((activity) => getActivityData(activity))

  const get = (activity: NavActivity['type']) => {
    return navActivities.find((item) => item.type === activity)!
  }

  const select = (activities: NavActivity['type'][]) => {
    if (activities.length === 0) return []
    return navActivities.filter((item) => {
      if (activities.includes(item.type)) return item
    })
  }

  const all = (options: { omit: NavActivity['type'][] } = { omit: [] }) => {
    if (options.omit.length === 0) return navActivities
    return navActivities.filter((item) => !options.omit.includes(item.type))
  }

  return {
    get,
    select,
    all,
  }
}
